import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  inProgress: false,
  pendingPath: null,
};

const onboardingNavigationGuardSlice = createSlice({
  name: 'onboardingNavigationGuard',
  initialState,
  reducers: {
    setOnboardingInProgress: (state, action) => {
      state.inProgress = !!action.payload;
    },
    setOnboardingPendingPath: (state, action) => {
      state.pendingPath = action.payload || null;
    },
    clearOnboardingPendingPath: (state) => {
      state.pendingPath = null;
    },
    resetOnboardingInProgress: () => initialState,
  },
});

export const {
  setOnboardingInProgress,
  setOnboardingPendingPath,
  clearOnboardingPendingPath,
  resetOnboardingInProgress,
} = onboardingNavigationGuardSlice.actions;

export default onboardingNavigationGuardSlice.reducer;
